module.exports = __webpack_public_path__ + "img/digital04.ac6e909e.jpg";